export default "__VITE_ASSET__B$sxkh0r__"